export const DISCOUNT_ADDED = 'Discount added';
export const DRAFT_ORDER_CREATED = 'Draft Order Created';
export const DRAFT_ORDER_CANCELLED = 'Draft Order Cancelled';
export const ORDER_CANCELLED = 'Order Cancelled';
export const LOGON_CANNOT_MODIFY_ORDER = 'One or more items on this order has a status that prevents you from modifying this order.';
export const LOGON_CANNOT_MODIFY_ORDER_AP = 'One or more items are either allocated or in pick. Therefore, order modification is limited.';
export const D365_CANNOT_MODIFY_ORDER_IC = 'Order is not in an editable status.';
export const LOGON_CANNOT_MODIFY_ORDER_ICU = 'One or more items are no longer in "N" status. Any modifications will need to be done in LogON directly!';
export const D365_ORDER_NOT_UPDATED = 'Order can not be updated! Proceed to manually update values in D365 if applicable.';
export const D365_CANNOT_MODIFY_ORDER = 'One or more items are no longer editable.'
export const ORDER_TOTAL_TOO_LARGE = 'Order total larger than maximum eligible amount';
export const ORDER_REFUND_TOO_LARGE = 'Order refund larger than maximum eligible amount';
export const ORDER_REFUNDED = 'Order refund successful.';
export const ORDER_REFUND_AVAILABLE = 'Order refund has been calculated.';
export const ORDER_SHIPPING_INVALID = 'Order Shipping Line is invalid';
export const ORDER_UPDATED = 'Order has been sent to Kitsilano';
export const ORDER_UPDATED_NOTE = 'Order note been updated in Shopify';
export const ORDER_DISCOUNT_INVALID = 'Order discount type is invalid';
export const CODE_NOT_FOUND = 'Not a valid code';
export const TAX_LINES_ARE_EMPTY = 'Order does not contain any tax lines.';
export const ORDER_RETURN_AUTHORIZATION_CREATED = 'Return Authorization created in D365';
export const ORDER_SHIPPING_PRICE_MISMATCH = 'Setting shipping to custom line due to price mismatch.';
export const ORDER_ERROR = 'There was an error calculating the refund. Please try again. If the problem persists please contact the devteam!'
